import { darkTheme, defaultTheme, changeTheme } from '@/themes';
import { Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTheme } from '../components/theme-provider';

const getMuiThemeFromSystem = () => {
    if (typeof window === 'undefined') return defaultTheme;
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return isDark ? darkTheme : defaultTheme;
};

export const useMuiTheme = (): Theme => {
    const { theme } = useTheme();

    const [muiTheme, setMuiTheme] = useState<Theme>(() =>
        changeTheme(theme === 'system' ? getMuiThemeFromSystem() : theme === 'dark' ? darkTheme : defaultTheme),
    );

    useEffect(() => {
        let newThemeOptions;
        if (theme === 'system') {
            newThemeOptions = getMuiThemeFromSystem();
        } else {
            newThemeOptions = theme === 'dark' ? darkTheme : defaultTheme;
        }
        setMuiTheme(changeTheme(newThemeOptions));

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleChange = () => {
            if (theme === 'system') {
                setMuiTheme(changeTheme(getMuiThemeFromSystem()));
            }
        };

        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [theme]);

    return muiTheme;
};
